import React, { ReactElement } from 'react'
import BarryIcon from 'components/Barry/BarryComponents/BarryIcon'
import useBarryDashboard from 'components/Barry/hooks/useBarryDashboard'

export default function DashboardBarryIcon({
  handleToggle,
  barryPopupMessage,
}: {
  handleToggle: () => void
  barryPopupMessage: React.ReactNode
}): ReactElement {
  const { handleProvisioningHelpPopupInteraction, hasProvisioningHelpPopup } = useBarryDashboard()

  return (
    <BarryIcon
      hasPopupMessage={hasProvisioningHelpPopup}
      barryPopupMessage={barryPopupMessage}
      handleToggle={handleToggle}
      onPopupInteraction={handleProvisioningHelpPopupInteraction}
    />
  )
}
